module.exports = function replaceTags(str) {
  if (str === null || str === "") return false;
  else str = str.toString();
  return str.replace(/<\w[^>]*>/g, "<span>").replace(/<\/[\w]*>/g, "</span>");
};
